"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var EllipsisDropdown = function EllipsisDropdown(props) {
  return /*#__PURE__*/_react.default.createElement(_antd.Dropdown, {
    overlay: props.menu,
    placement: props.placement,
    trigger: ['click']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ellipsis-dropdown"
  }, /*#__PURE__*/_react.default.createElement(_icons.EllipsisOutlined, null)));
};

EllipsisDropdown.defaultProps = {
  trigger: 'click',
  placement: 'bottomRight',
  menu: /*#__PURE__*/_react.default.createElement(_antd.Menu, null)
};
var _default = EllipsisDropdown;
exports.default = _default;